import { useTranslation } from 'react-i18next';
import { Button, Dialog } from '@platform/ui';
import type { IConfirmDialogProps } from './IConfirmDialogProps';

/**
 * Діалог підтвердження (UIUX patterns/confirmations, layout/dialogs): питання із назвою об'єкта, пояснення, «Скасувати» (отримує фокус
 * першим) і кнопка дії з дієсловом — руйнівна в кольорі --danger. Esc, клік по тлу і × — відмова.
 */
export function ConfirmDialog({ title, text, confirmLabel, cancelLabel, danger, onClose }: IConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog title={title} onClose={() => onClose(false)}
      footer={<>
        <Button onClick={() => onClose(false)}>{cancelLabel ?? t('recordPage.confirmCancel')}</Button>
        <Button variant={danger ? 'danger' : 'primary'} className={danger ? 'btn--danger-solid' : undefined} onClick={() => onClose(true)}>{confirmLabel}</Button>
      </>}>
      {text && <p className="confirm__text">{text}</p>}
    </Dialog>
  );
}
